import { FETCH_TODO, FETCH_TODO_LOADING, FETCH_TODO_ERROR } from 'redux/Actions/ToDo/actionTypes';

const initialState = {
  response: [],
  loading: false,
  error: {},
};

const ToDoReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_TODO:
      return {
        ...state,
        response: action.payload && action.payload.data,
        loading: false,
        error: {},
      };
    case FETCH_TODO_LOADING:
      return {
        ...state,
        response: [],
        loading: true,
        error: {},
      };
    case FETCH_TODO_ERROR:
      return {
        ...state,
        response: [],
        error: { ...action.error },
        loading: false,
      };
    default:
      return state;
  }
};

export default ToDoReducer;
